/**
 * Team, People (plan docs/plans/lms-plan.md 13 tab 6 "People (the directory
 * with a person page: transcript, assignments, waivers, sign-offs, external
 * certificates, onboarding runs, the training log button)"; 8.4, 10.5, 18.20,
 * 18.21; R16, R17, R18, R22; WP-45).
 *
 * Replaces WP-03's placeholder in place: tabs/team/subviews.ts imports this
 * file's DEFAULT export (no props), mounted at /lms/team/people/* (plan 18.3),
 * so it routes its own deeper paths:
 *
 *   /lms/team/people            the directory (Directory)
 *   /lms/team/people/:userId    one person's page (PersonPage)
 *
 * Anything deeper goes back to the directory.
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { PEOPLE_BASE } from '../matrix/shared';
import Directory from './Directory';
import PersonPage from './PersonPage';

export function PeopleView() {
  return (
    <div data-testid="lms-people">
      <Routes>
        <Route index element={<Directory />} />
        <Route path=":userId" element={<PersonPage />} />
        <Route path="*" element={<Navigate to={PEOPLE_BASE} replace />} />
      </Routes>
    </div>
  );
}

export default PeopleView;
